import { User } from 'features/user'
import { Can } from 'providers/casl'
import { onWorkspaceSelectUse } from '../features/workspace'
import { onAdmin } from './onAdmin'
import { onAdops } from './onAdops'
import { onBackOffice } from './onBackOffice'
import { onCustomerPerformance } from './onCustomerPerformance'
import { onCustomerSuccess } from './onCustomerSuccess'

export const userByRole = (user: User, can: Can) => {
  switch (user.role) {
    case 'admin': {
      onAdmin(can)
      break
    }
    case 'adops': {
      onAdops(can)
      break
    }
    case 'backOffice': {
      onBackOffice(can)
      break
    }
    case 'customerPerformance': {
      onCustomerPerformance(can)
      break
    }
    case 'customerSuccess': {
      onCustomerSuccess(can)
      break
    }
    case 'publisher': {
      // This includes all Publisher's sub roles.
      // If you want to define abilities for a specific Publisher sub role
      // use `providers/casl/abilities/userByWorkspaceRole`.
      onWorkspaceSelectUse(can)
      break
    }
  }
}
